import { Button as MuiButton } from "@material-ui/core";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
type Props = {
  children: any;
  style?: "submit" | "save" | "approve" | "reject" | "decline";
  type?: "button" | "reset" | "submit";
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  className?: string;
};

const useStyles = makeThemedStyles("AdminButton", (theme) => ({
  submitButton: {
    backgroundColor: "#aaaaaa",
    borderRadius: "4px",
    color: "#fff",
    width: "auto",
    padding: "3px 10px 2px 10px",
    fontSize: "12px",
    height: "30px",
    "& .MuiButton-label": {
      fontSize: "14px",
    },
    "&.MuiButton-root:hover": {
      backgroundColor: "rgb(14, 37, 106)",
    },
  },
  saveButton: {
    background: "rgb(0, 169, 163)",
    "&:hover": {
      backgroundColor: "rgb(0, 169, 163, 0.7)",
    },
  },
  approveButton: {
    background: "rgb(0, 169, 163)",
    "&:hover": {
      backgroundColor: "rgb(0, 169, 163, 0.7)",
    },
  },
  rejectButton: {
    background: "rgb(126, 135, 145)",
    "&:hover": {
      backgroundColor: "rgb(126, 135, 145, 0.7)",
    },
  },
  declineButton: {
    background: "rgb(226, 35, 45)",
    "&:hover": {
      backgroundColor: "rgb(126, 135, 145, 0.7)",
    },
  },
}));

const AdminButton = (props: Props) => {
  const classes = useStyles();
  const pickStyle =
    props.style === "approve"
      ? classes.approveButton
      : props.style === "reject"
      ? classes.rejectButton
      : props.style === "decline"
      ? classes.declineButton
      : props.style === "save"
      ? classes.saveButton
      : "";
  return (
    <MuiButton
      type={props.type}
      className={`${classes.submitButton} ${props.className} ${pickStyle}`}
      onClick={props.onClick}
    >
      {props.children}
    </MuiButton>
  );
};

export default AdminButton;
